// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import { getWebComponentInstance } from 'fg-frontend/src/webComponents/decorate';

const fragments = {
	ITEM: '[data-fragment="ZigZagContentSwitcher.item"]',
	CONTENT: '[data-fragment="ZigZagContentSwitcher.content"]',
};

class ZigZagContentSwitcher extends WebComponent {
	constructor(props) {
		super(props);
	}

	didMount() {
		const {
			activeItemClass,
			activeContentClass,
		} = this.props;
		this.activeItemClass = activeItemClass;
		this.activeContentClass = activeContentClass;

		this.itemsElement = this.element.querySelectorAll(fragments.ITEM);
		this.contentsElement = this.element.querySelectorAll(fragments.CONTENT);

		this.initListeners();
	}

	initListeners = () => {
		this.itemsElement.forEach(item => item.addEventListener('click', this.handleClickOnItem));
	}

	handleClickOnItem = (e) => {
		e.preventDefault();
		/* pause video */
		let youtubeVideo = this.element.querySelector(".zig-zag__content-switch-content--active .yt-player-wrap");
		if(youtubeVideo) {
			let youtubeVideoComponent = getWebComponentInstance(youtubeVideo);
			youtubeVideoComponent.stopVideo();
		}
		this.itemsElement.forEach(item => item.classList.remove(this.activeItemClass));
		this.contentsElement.forEach(item => item.classList.remove(this.activeContentClass));
		e.target.classList.add(this.activeItemClass);
		let showContent = this.element.querySelector(fragments.CONTENT+`[data-id="${e.target.dataset.id}"]`);
		if(showContent) {
			showContent.classList.add(this.activeContentClass);
		}
	}
}

ZigZagContentSwitcher.defaultProps = {
	activeItemClass: 'zig-zag__content-switch-item--active',
	activeContentClass: 'zig-zag__content-switch-content--active',
};

export default ZigZagContentSwitcher;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/ZigZagContentSwitcher.js